'use client';

import { motion, type Variants } from 'framer-motion';
import { cn } from '@/app/utils';

export const EASE_OUT_CUBIC = [0.33, 1, 0.68, 1] as const;

export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: EASE_OUT_CUBIC },
  },
};

export function SectionShell({
  children,
  className,
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <motion.section
      className={cn('relative w-full px-6 py-20 sm:px-4 sm:py-12', className)}
      id={id}
      initial={{ opacity: 0, y: 48 }}
      transition={{ duration: 0.7, ease: EASE_OUT_CUBIC }}
      viewport={{ once: true, margin: '-80px' }}
      whileInView={{ opacity: 1, y: 0 }}
    >
      <div className="mx-auto w-full max-w-[1104px]">{children}</div>
    </motion.section>
  );
}
